import { updateState, withDevtools } from '@angular-architects/ngrx-toolkit';
import { inject } from '@angular/core';
import { tapResponse } from '@ngrx/operators';
import { signalStore, withMethods, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { setError, setFulfilled, setPending, withRequestStatus } from '@shared/state/request-status.feature';
import { filter, pipe, switchMap, tap } from 'rxjs';
import { CMSPaginatedResponse } from '../model/cms-response.model';
import { ExternalResource } from '../model/external-resource.model';
import { KnowledgeService } from '../service/knowledge.service';

export const ExternalResourceStore = signalStore(
  withDevtools('external-resource'),
  withState({
    data: null as CMSPaginatedResponse<ExternalResource> | null,
  }),
  withRequestStatus(),
  withMethods((store, knowledgeService = inject(KnowledgeService)) => ({
    load: rxMethod<void>(
      pipe(
        filter(() => !store.isFulfilled()),
        tap(() => updateState(store, '[ExternalResourceStore] Set pending', setPending())),
        switchMap(() =>
          knowledgeService.getExternalResources().pipe(
            tapResponse({
              next: (data) => {
                updateState(store, '[ExternalResourceStore] Set fulfilled', setFulfilled());
                updateState(store, '[ExternalResourceStore] Set data', { data });
              },
              error: () => {
                updateState(store, '[ExternalResourceStore] Set error', setError());
                updateState(store, '[ExternalResourceStore] Set data', { data: null });
              },
            }),
          ),
        ),
      ),
    ),
  })),
);
